import permissionLevel from '../permissionLevel';
import { updateStatuses } from '../statuses';

export const getAppliedPermission = (state) => {
    const isReady = state.permissions.updateStatus == updateStatuses.success;
    let appliedPermissionLevel;
    let groupName;

    if(isReady) {
        const appliedPermissions = state.permissions.value.value;
        appliedPermissionLevel = appliedPermissions.length == 0 ? permissionLevel.everyone : permissionLevel.groupBased;

        if(appliedPermissionLevel == permissionLevel.groupBased) {
            groupName = appliedPermissions[0].groupName;
        }
    }

    return {
        permissionLevel: appliedPermissionLevel,
        groupName: groupName
    };
};



// WEBPACK FOOTER //
// ./src/js/projections/permissions.js